var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.isThirdModal
        ? _c("ModalFullScreen", {
            attrs: {
              withBgClickEvent: true,
              size: "3xl",
              modalId: "modal-lv2",
            },
            on: {
              close: function ($event) {
                return _vm.$emit("close")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex justify-between bg-white pr-4 sm:pr-6 sm:p-2 pl-0 mb-3",
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "text-lg leading-6 font-medium text-gray-900",
                            },
                            [_vm._v(" Upload Resume ")]
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "cursor-pointer flex items-center justify-center absolute top-6 right-6",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                            mouseover: function ($event) {
                              _vm.isHovered = true
                            },
                            mouseout: function ($event) {
                              _vm.isHovered = false
                            },
                          },
                        },
                        [
                          !_vm.isHovered
                            ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                            : _vm._e(),
                          _vm.isHovered
                            ? _c("CrossIconHover", {
                                staticClass: "close-icon",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "LoadingOverlay",
                        {
                          attrs: {
                            hasData: _vm.isResumeData,
                            loading: _vm.loading,
                          },
                        },
                        [
                          _c("InformationWrapper", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "primary",
                                  fn: function () {
                                    return [
                                      _c(
                                        "InformationCard",
                                        {
                                          attrs: {
                                            title: "Background",
                                            contentHorizontalPadding: "px-8",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mb-6 flex warningText w-full",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mt-0.5 h-4 w-auto",
                                                  attrs: {
                                                    alt: "delete notes",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 16 16",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id: "Icon / InfoCircleFilled",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              id: "Vector",
                                                              d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                                              fill: "#070823",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "child ml-2" },
                                                [
                                                  _vm._v(
                                                    " Before you save the resume onto the Resource profile please verify all information is correct. "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col w-full justify-between items-start mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Skills "),
                                                      _vm.skills2.length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm.skills2
                                                                      ?.length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "absolute",
                                                        class: {
                                                          "right-4":
                                                            _vm.skills2 &&
                                                            _vm.skills2.length >
                                                              0,
                                                          "right-auto":
                                                            _vm.skills2
                                                              .length === 0,
                                                        },
                                                        attrs: {
                                                          label:
                                                            _vm.skills2
                                                              ?.length > 0
                                                              ? `edit`
                                                              : `add black`,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openSkillModal()
                                                          },
                                                        },
                                                      }),
                                                      _vm.skills2?.length > 0
                                                        ? _c("UiButton", {
                                                            staticClass:
                                                              "absolute right-0",
                                                            attrs: {
                                                              label:
                                                                _vm.skills2
                                                                  ?.length >
                                                                  0 &&
                                                                `delete black`,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openSkillModal()
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              !_vm.isLoadingSkills
                                                ? _c("div", [
                                                    _vm.skills2.length
                                                      ? _c(
                                                          "div",
                                                          [
                                                            !_vm.isLoadingSkills &&
                                                            _vm.skills2.length
                                                              ? _c(
                                                                  "ChipsWithMore",
                                                                  {
                                                                    attrs: {
                                                                      chipWithLinkDatas:
                                                                        _vm.skills2,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-normal text-base text-gray-new",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " No tags added. "
                                                            ),
                                                          ]
                                                        ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col w-full justify-between items-start mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Languages "),
                                                      _vm.languagesByManagement
                                                        ?.length
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .languagesByManagement
                                                                      ?.length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass:
                                                          "absolute right-0",
                                                        class: {
                                                          "right-4":
                                                            _vm.languagesByManagement &&
                                                            _vm
                                                              .languagesByManagement
                                                              .length > 0,
                                                          "right-auto":
                                                            _vm
                                                              .languagesByManagement
                                                              .length === 0,
                                                        },
                                                        attrs: {
                                                          label:
                                                            _vm
                                                              .languagesByManagement
                                                              ?.length > 0
                                                              ? `edit`
                                                              : `add black`,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openLanguageModal()
                                                          },
                                                        },
                                                      }),
                                                      _vm.languagesByManagement
                                                        ?.length > 0
                                                        ? _c("UiButton", {
                                                            staticClass:
                                                              "absolute right-0",
                                                            attrs: {
                                                              label:
                                                                _vm
                                                                  .languagesByManagement
                                                                  ?.length >
                                                                  0 &&
                                                                `delete black`,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openLanguageModal()
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              !_vm.isLoadingLang
                                                ? _c("div", [
                                                    _vm.languagesByManagement
                                                      .length
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _vm
                                                              .languagesByManagement
                                                              .length > 0
                                                              ? _c(
                                                                  "ChipsWithMore",
                                                                  {
                                                                    attrs: {
                                                                      chipWithLinkDatas:
                                                                        _vm.languagesByManagement,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-normal text-base text-gray-new",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " No languages added. "
                                                            ),
                                                          ]
                                                        ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col w-full justify-between items-start",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Experience "),
                                                      _vm
                                                        .experiencesByManagement
                                                        ?.length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .experiencesByManagement
                                                                      ?.length
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass:
                                                          "absolute right-0",
                                                        attrs: {
                                                          label: "add black",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openExperienceModal(
                                                              null
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm.experiencesByManagement
                                                ?.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-full mb-10",
                                                    },
                                                    [
                                                      _vm
                                                        .experiencesByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "div",
                                                            _vm._l(
                                                              _vm.experiencesByManagement,
                                                              function (
                                                                experience,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: experience.id,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "font-normal text-lg rounded p-4 w-full mb-4 borderGreen flex flex-row justify-between items-start",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "font-400 labelWidth leading-normal mb-0.5 text-primary-black text-base",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      experience.job_title
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "flex flex-row text-storm-gray font-400 text-base mb-1.5 leading-normal",
                                                                              },
                                                                              [
                                                                                experience.company_name
                                                                                  ? _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            experience.company_name
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "p-2",
                                                                                  },
                                                                                  [
                                                                                    experience.company_name &&
                                                                                    experience.employment_type
                                                                                      ? _c(
                                                                                          "DotIcon"
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                                experience.employment_type
                                                                                  ? _c(
                                                                                      "p",
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              experience.employment_type
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ]
                                                                            ),
                                                                            experience.start_date
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "flex flex-row text-gray-new font-400 text-sm mb-2 leading-4",
                                                                                  },
                                                                                  [
                                                                                    experience.start_date
                                                                                      ? _c(
                                                                                          "p",
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm.formattedStartDate(
                                                                                                    experience.start_date
                                                                                                  )
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    experience.start_date &&
                                                                                    experience.end_date
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "px-0.5 text-gray-new font-300 text-sm",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "-"
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _c(
                                                                                      "p",
                                                                                      [
                                                                                        _vm._v(
                                                                                          " " +
                                                                                            _vm._s(
                                                                                              _vm.formattedStartDate(
                                                                                                experience.end_date
                                                                                              )
                                                                                            ) +
                                                                                            " "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "flex flex-row",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "text-gray-new font-300 text-sm",
                                                                                          }
                                                                                        ),
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "p-2",
                                                                                          },
                                                                                          [
                                                                                            experience.location &&
                                                                                            experience.end_date
                                                                                              ? _c(
                                                                                                  "DotIcon",
                                                                                                  {}
                                                                                                )
                                                                                              : _vm._e(),
                                                                                          ],
                                                                                          1
                                                                                        ),
                                                                                        experience.location
                                                                                          ? _c(
                                                                                              "p",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mb-0.5",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      experience.location
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            experience.summary
                                                                              ? _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "xxlLabelContainer mb-0.5",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "CollapsibleDescription",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            description:
                                                                                              experience.summary,
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "flex flex-row items-center",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "UiButton",
                                                                              {
                                                                                staticClass:
                                                                                  "absolute right-4",
                                                                                attrs:
                                                                                  {
                                                                                    label:
                                                                                      "edit",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.openExperienceModal(
                                                                                        experience,
                                                                                        index
                                                                                      )
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                            _vm
                                                                              .experiencesByManagement
                                                                              ?.length >
                                                                            0
                                                                              ? _c(
                                                                                  "UiButton",
                                                                                  {
                                                                                    staticClass:
                                                                                      "absolute right-0",
                                                                                    attrs:
                                                                                      {
                                                                                        label:
                                                                                          _vm
                                                                                            .experiencesByManagement
                                                                                            ?.length >
                                                                                            0 &&
                                                                                          `delete black`,
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.deleteExperience(
                                                                                            index
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new mb-10",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No experience added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-col w-full relative justify-between items-start mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg w-35 text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Education "),
                                                      _vm.educationsByManagement
                                                        ?.length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .educationsByManagement
                                                                      ?.length
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c("UiButton", {
                                                    staticClass:
                                                      "absolute right-0",
                                                    attrs: {
                                                      label: "add black",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openEducationModal(
                                                          null
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.educationsByManagement
                                                ?.length > 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "w-full" },
                                                    _vm._l(
                                                      _vm.educationsByManagement,
                                                      function (
                                                        education,
                                                        index
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: education.title,
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "font-normal text-lg rounded p-4 w-full mb-4 borderGreen flex flex-row justify-between items-start",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "font-400 labelWidth leading-normal mb-0.5 text-primary-black text-base",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            education.title
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  education.institution
                                                                    ? _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "text-storm-gray font-400 text-base mb-1.5",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                education.institution
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  education.title &&
                                                                  education.institution
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "flex flex-row text-gray-new font-400 text-sm mb-2",
                                                                        },
                                                                        [
                                                                          _vm.formattedStartDate(
                                                                            education.start_date
                                                                          )
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "leading-4",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.formattedStartDate(
                                                                                          education.start_date
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm.formattedStartDate &&
                                                                          _vm.formattedEndDate
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "px-0.5 text-gray-new font-300 text-sm leading-4",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "-"
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm.formattedEndDate(
                                                                            education.end_date
                                                                          )
                                                                            ? _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "leading-4",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.formattedEndDate(
                                                                                          education.end_date
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0.5 font-300 text-sm text-primary-black customLineH",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            education.summary
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "flex flex-row items-center",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "UiButton",
                                                                      {
                                                                        staticClass:
                                                                          "absolute right-4",
                                                                        attrs: {
                                                                          label:
                                                                            "edit",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.openEducationModal(
                                                                                education,
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm
                                                                      .educationsByManagement
                                                                      ?.length >
                                                                    0
                                                                      ? _c(
                                                                          "UiButton",
                                                                          {
                                                                            staticClass:
                                                                              "absolute right-0",
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  _vm
                                                                                    .educationsByManagement
                                                                                    ?.length >
                                                                                    0 &&
                                                                                  `delete black`,
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteEducation(
                                                                                    index
                                                                                  )
                                                                                },
                                                                            },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No education added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "relative w-full mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Websites "),
                                                      _vm.websitesByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .websitesByManagement
                                                                      .length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex flex-row items-center",
                                                        },
                                                        [
                                                          _c("UiButton", {
                                                            staticClass:
                                                              "absolute",
                                                            class: {
                                                              "right-4":
                                                                _vm
                                                                  .websitesByManagement
                                                                  .length > 0,
                                                              "right-auto":
                                                                _vm
                                                                  .websitesByManagement
                                                                  .length === 0,
                                                            },
                                                            attrs: {
                                                              label:
                                                                _vm
                                                                  .websitesByManagement
                                                                  .length > 0
                                                                  ? `edit`
                                                                  : `add black`,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openEditModal(
                                                                  _vm
                                                                    .websitesByManagement
                                                                    .length > 0
                                                                    ? _vm
                                                                        .websitesByManagement[0]
                                                                        .name
                                                                    : ""
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm
                                                            .websitesByManagement
                                                            .length > 0
                                                            ? _c("UiButton", {
                                                                staticClass:
                                                                  "absolute right-0",
                                                                attrs: {
                                                                  label:
                                                                    "delete black",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteWebsite(
                                                                        _vm
                                                                          .websitesByManagement[0]
                                                                          .name
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              !!_vm.websitesByManagement.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-col gap-3",
                                                    },
                                                    [
                                                      !!_vm.websitesByManagement
                                                        .length
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "flex flex-col gap-3",
                                                            },
                                                            _vm._l(
                                                              _vm.websitesByManagement,
                                                              function (
                                                                website
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: website.name,
                                                                    staticClass:
                                                                      "flex flex-row items-center relative justify-between",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "parentBox relative",
                                                                      },
                                                                      [
                                                                        website
                                                                          ? _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "text-light-green hover:text-badgeBlue text-base font-normal no-underline customLineH",
                                                                                attrs:
                                                                                  {
                                                                                    href: website.name,
                                                                                    target:
                                                                                      "”_blank”",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      website.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No website added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "relative w-full mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Emails "),
                                                      _vm.emailByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .emailByManagement
                                                                      .length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex flex-row items-center",
                                                        },
                                                        [
                                                          _c("UiButton", {
                                                            staticClass:
                                                              "absolute",
                                                            class: {
                                                              "right-4":
                                                                _vm
                                                                  .emailByManagement
                                                                  .length > 0,
                                                              "right-auto":
                                                                _vm
                                                                  .emailByManagement
                                                                  .length === 0,
                                                            },
                                                            attrs: {
                                                              label:
                                                                _vm
                                                                  .emailByManagement
                                                                  .length > 0
                                                                  ? `edit`
                                                                  : `add black`,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openEditModalEmail(
                                                                  _vm
                                                                    .emailByManagement
                                                                    .length > 0
                                                                    ? _vm
                                                                        .emailByManagement[0]
                                                                        .name
                                                                    : ""
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm.emailByManagement
                                                            .length > 0
                                                            ? _c("UiButton", {
                                                                staticClass:
                                                                  "absolute right-0",
                                                                attrs: {
                                                                  label:
                                                                    "delete black",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.deleteEmail(
                                                                        _vm
                                                                          .emailByManagement[0]
                                                                          .name
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              !!_vm.emailByManagement.length
                                                ? _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-col gap-4",
                                                      },
                                                      [
                                                        !!_vm.emailByManagement
                                                          .length
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex flex-col gap-3",
                                                              },
                                                              _vm._l(
                                                                _vm.emailByManagement,
                                                                function (
                                                                  email
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key: email.name,
                                                                      staticClass:
                                                                        "flex flex-row items-center relative justify-between",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "parentBox relative",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "MailTo",
                                                                            {
                                                                              staticClass:
                                                                                "text-light-green hover:text-badgeBlue text-base font-normal customLineH",
                                                                              attrs:
                                                                                {
                                                                                  email:
                                                                                    email.name,
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ])
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No email added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "relative w-full mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Work Phone "),
                                                      _vm.phoneByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .phoneByManagement
                                                                      .length
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "absolute",
                                                        class: {
                                                          "right-4":
                                                            _vm
                                                              .phoneByManagement
                                                              .length > 0,
                                                          "right-auto":
                                                            _vm
                                                              .phoneByManagement
                                                              .length === 0,
                                                        },
                                                        attrs: {
                                                          label:
                                                            _vm
                                                              .phoneByManagement
                                                              .length > 0
                                                              ? `edit`
                                                              : `add black`,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openEditModalPhone(
                                                              _vm
                                                                .phoneByManagement
                                                                .length > 0
                                                                ? _vm
                                                                    .phoneByManagement[0]
                                                                    .name
                                                                : ""
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm.phoneByManagement
                                                        .length > 0
                                                        ? _c("UiButton", {
                                                            staticClass:
                                                              "absolute right-0",
                                                            attrs: {
                                                              label:
                                                                !!_vm
                                                                  .phoneByManagement
                                                                  .length &&
                                                                `delete black`,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deletePhone(
                                                                  _vm
                                                                    .phoneByManagement[0]
                                                                    .name
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm.phoneByManagement.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "parentBox flex flex-col gap-3",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        _vm._l(
                                                          _vm.phoneByManagement,
                                                          function (phone) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: phone.name,
                                                                staticClass:
                                                                  "flex flex-row items-center",
                                                              },
                                                              [
                                                                _c("PhoneTo", {
                                                                  staticClass:
                                                                    "block underline font-normal text-base text-lightGreen hover:text-badgeBlue no-underline customLineH",
                                                                  attrs: {
                                                                    phone:
                                                                      phone.name,
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No phone number added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "relative w-full mb-10",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-row justify-between items-start w-full",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg text-primary-black",
                                                    },
                                                    [
                                                      _vm._v(" Location "),
                                                      _vm.locationByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "totalNumber ml-0.5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement
                                                                      .length
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c("UiButton", {
                                                        staticClass: "absolute",
                                                        class: {
                                                          "right-4":
                                                            _vm
                                                              .locationByManagement
                                                              .length > 0,
                                                          "right-auto":
                                                            _vm.locationByManagement ===
                                                            0,
                                                        },
                                                        attrs: {
                                                          label:
                                                            _vm
                                                              .locationByManagement
                                                              .length > 0
                                                              ? `edit`
                                                              : `add black`,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openLocationModal()
                                                          },
                                                        },
                                                      }),
                                                      _vm.locationByManagement
                                                        .length > 0
                                                        ? _c("UiButton", {
                                                            staticClass:
                                                              "absolute right-0",
                                                            attrs: {
                                                              label:
                                                                "delete black",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteLocation()
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm.locationByManagement.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "parentBox flex flex-col gap-3",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        _vm._l(
                                                          _vm.locationByManagement,
                                                          function (location) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: location.city,
                                                                staticClass:
                                                                  "flex flex-row items-center",
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "block underline font-normal text-lightGreen hover:text-badgeBlue no-underline customLineH",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          location.city
                                                                        ) +
                                                                        _vm._s(
                                                                          location.state &&
                                                                            location.city &&
                                                                            ","
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          location.state
                                                                        ) +
                                                                        _vm._s(
                                                                          location.state &&
                                                                            location.city &&
                                                                            location.postalCode &&
                                                                            ","
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          location.postalCode
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          location.state &&
                                                                            location.city &&
                                                                            location.postalCode &&
                                                                            location.country &&
                                                                            ","
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          location.country
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-normal text-base text-gray-new",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " No location added. "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex w-full justify-end mb-3 mr-6",
                                          },
                                          [
                                            _c("UIButton", {
                                              staticClass: "mr-3",
                                              attrs: {
                                                buttonText: "Cancel",
                                                variant: "outline",
                                                size: "lg",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit("close")
                                                },
                                              },
                                            }),
                                            _c("UIButton", {
                                              attrs: {
                                                buttonText: "Save and Upload",
                                                variant: "black",
                                                size: "lg",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.upsertProfileByManagement()
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1927790182
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2048030221
            ),
          })
        : _vm._e(),
      _vm.websiteModal
        ? _c("ManageWebsite", {
            attrs: { website: _vm.websiteToEdit },
            on: {
              close: () => {
                _vm.websiteModal = false
                this.isThirdModal = false
              },
              "add-website": _vm.addWebsite,
              "edit-website": _vm.editWebsite,
            },
          })
        : _vm._e(),
      _vm.emailModal
        ? _c("ManageEmail", {
            attrs: { email: _vm.emailToEdit },
            on: {
              "add-email": _vm.addEmail,
              "edit-email": _vm.editEmail,
              close: () => {
                _vm.emailModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.educationModal
        ? _c("ManageEducations", {
            attrs: { educations: _vm.educationToEdit },
            on: {
              "edit-education": _vm.editEducation,
              "add-education": _vm.addEducation,
              close: () => {
                _vm.educationModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.experienceModal
        ? _c("ManageExpeirence", {
            attrs: { experiences: _vm.experienceToEdit },
            on: {
              "edit-experience": _vm.editExperience,
              "add-experience": _vm.addExperience,
              close: () => {
                _vm.experienceModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.skilllsModal
        ? _c("ManageSkills", {
            attrs: { skillsIds: _vm.skillsIds },
            on: {
              "add-skill": _vm.addSkill,
              close: () => {
                _vm.skilllsModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.languagesModal
        ? _c("ManageLanguages", {
            attrs: {
              language: _vm.langName,
              contractorUserId: this.contractorUserId,
              currentUserId: this.currentUserId,
            },
            on: {
              "add-languages": _vm.addlanguages,
              close: () => {
                _vm.languagesModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.phoneModal
        ? _c("ManagePhone", {
            attrs: { phone: _vm.phoneToEdit },
            on: {
              "add-phone": _vm.addPhone,
              "edit-phone": _vm.editPhone,
              close: () => {
                _vm.phoneModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
      _vm.locationModal
        ? _c("ManageLocation", {
            attrs: { location: _vm.locationByManagement },
            on: {
              "edit-location": _vm.editLocation,
              "add-location": _vm.addLocation,
              close: () => {
                _vm.locationModal = false
                this.isThirdModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }